var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3DIconMographical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 165,
    viewBox: "0 0 143 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.206 148.012V96.235L75.6893 111.138V162.915L51.206 148.012Z",
    fill: "#212121",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6893 163.169V110.08L100.173 99.4351V152.524L75.6893 163.169Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 60.6626V37.9757L113.99 105.956V135.756L2.5 60.6626Z",
    fill: "#212121",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1481 118.074V90.8171L29.6314 103.132V132.977L5.1481 118.074Z",
    fill: "#212121",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.99 135.608V105.594L141.019 92.3615V122.375L113.99 135.608Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6314 133.165V103.144L74.265 81.6539V111.675L29.6314 133.165Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.83 92.771L86.1515 74.5196L139.339 49.3503L137.054 73.579L102.83 92.771Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6438 37.0131L31.2084 27.6125L140.396 92.606L113.201 105.829L2.6438 37.0131Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24301 89.6364L50.3082 67.6545L74.1701 81.9718L29.1049 103.954L5.24301 89.6364Z",
    fill: "#F5F5F5",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4953 56.34L116.945 38.572L138.124 49.4305L95.1898 70.5569L71.4953 56.34Z",
    fill: "url(#paint0_linear_7_179)",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.206 63.9561V12.1793L73.6893 27.0822V78.859L49.206 63.9561Z",
    fill: "#212121",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6893 79.1138V26.0246L100.173 15.3795V68.4687L75.6893 79.1138Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4023 12.5139L74.2069 1.43084L98.9763 15.7403L74.1718 26.8233L49.4023 12.5139Z",
    fill: "url(#paint1_linear_7_179)",
    stroke: "black",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_179",
    x1: 91.3927,
    y1: 58.5887,
    x2: 136.498,
    y2: 31.0431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B61CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_179",
    x1: 86.8506,
    y1: 4.43173,
    x2: 57.5835,
    y2: 27.8454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D57BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DIconMographical);
export default __webpack_public_path__ + "static/media/3D Icon Mographical.ddf9f8b0a215e4ef86fe1bf20ffe165d.svg";
export { ForwardRef as ReactComponent };